<template>
	<div class="content">
		<router-view />
	</div>
</template>

<script>
	export default {
		created() {
			if(!this.allow_user("super-admin|operation-admin|film-admin")) {
				this.$router.replace("/");
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Actors.vue